// Become logo with transparent background (dark background removed via image processing)
const LOGO_URL = "/become-logo-transparent.png";

export const BecomeLogo = ({ className = "", size = "default", showText = true }) => {
  // Size presets
  const sizes = {
    small: { height: 40 },
    default: { height: 56 },
    large: { height: 72 },
    hero: { height: 160 },
  };

  const s = sizes[size] || sizes.default;

  return (
    <img 
      src={LOGO_URL}
      alt="Become"
      className={className}
      style={{ 
        height: s.height, 
        width: 'auto',
        objectFit: 'contain'
      }}
    />
  );
};
